import MembershipCardSvg from '@my-pages/features/membership/components/MembershipCardSvg.tsx';
import { SuspenseQueryErrorHandling } from '@shared/components/SuspenseQueryErrorHandling';

const MembershipCard = () => {
    return (
        <div
            className='modal fade'
            id='membershipCardModal'
            tabIndex={-1}
            aria-labelledby='exampleModalLabel'
            aria-hidden='true'
        >
            <div className='modal-dialog modal-lg'>
                <div className='modal-content'>
                    <div className='modal-body p-2 highlight-block'>
                        <SuspenseQueryErrorHandling errorMessage='Kunde inte hämta uppgifter kring ditt medlemskap.'>
                            <MembershipCardSvg />
                        </SuspenseQueryErrorHandling>
                    </div>
                    <div className='modal-footer p-1'>
                        <button
                            type='button'
                            className='btn btn-sm btn-secondary'
                            data-dismiss='modal'
                        >
                            Stäng
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MembershipCard;
